import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCustomer, setDelivery, setStep } from '@redux/actions/NewOrderActions/actions';

const mapStateToProps = (state) => {
  const { NewOrderReducer, VivoStoreReducer } = state;
  const { activeStep, customer } = NewOrderReducer;
  return {
    $state: {
      step: activeStep,
      name: customer.name,
      email: customer.email,
      phone: customer.phone,
      zipCode: customer.delivery.zipCode,
      storeDelivery: customer.delivery.isChartered,
      storeAddress: VivoStoreReducer.address,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  $actions: bindActionCreators(
    { setCustomer, setDelivery, setStep },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
